"use strict";

var Constants = require("../designer/Constants");

var Dispatcher = require("../dispatcher/Dispatcher");

var TabStore = require("../stores/TabStore");

var TabActions = {
	initializeStore: function (options) {
		var action = Object.assign({}, options, { actionType: Constants.TABS_INITIALIZE });
		Dispatcher.dispatch(action);
	},

	openTab: function (event) {
		if (!event || !event.target || event.type !== "click") {
			return false;
		}

		var isDesigner = TabStore.get("isDesignMode");
		if (isDesigner && event.type === "click" && !event.ctrlKey && !event.metaKey) {
			return true;
		}
		if (!isDesigner) {
			event.preventDefault();
			event.stopPropagation();
		}

		var $target = $(event.target);
		var dataTab = $target.closest("[data-tab]").attr("data-tab");
		var $tabContainer = $target.parents("[data-component='tabsContainer']").first();
		var $tabContentContainer = $tabContainer.children("[data-component='tabsContainer.contentContainer']").first();
		var $selectedTabContents = $tabContentContainer.children(`[data-tab="${dataTab}"]`);

		if ($selectedTabContents.length <= 0) {
			return false;
		}

		// Hide all content blocks and deselect the tab
		$tabContentContainer.children().addClass("hiddenTabContent");
		$tabContainer.find(".selected").removeClass("selected");
		// Select the clicked tab and show the related content div
		$target.closest("li").addClass("selected");
		$selectedTabContents.removeClass("hiddenTabContent");

		return true;
	}
};

module.exports = TabActions;